export default __webpack_public_path__ + "static/media/step8_poi_image1.18ae63c4.jpg";